($ => {

	'use strict';

	function init() {

		toggleFilter()
        
	}

    function toggleFilter(){

        let filters = document.querySelectorAll('.listingFilter__item');

        for (let i = 0; i < filters.length; i++) {
            filters[i].addEventListener('click', function(event) {

                let addClass = this.classList.contains("active");

                for (let i = 0; i < filters.length; i++) {
                    filters[i].classList.remove("active");
                }
                
                if(!addClass){
                    this.classList.add("active");
                }
                

            });
        }

    }

	$(document).ready(() => {
		init();
	});

})(jQuery);
